import GiftBoxApi from '@apis/gift/GiftBoxApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetGiftBoxParams, GiftBoxType, GiftItemType } from '@models/gift';

const giftBoxQueries = createQueryKeys('giftBox', {
    list: (giftBoxType: GiftBoxType, sorter: string) => ({
        queryKey: [giftBoxType, sorter],
        queryFn: () => GiftBoxApi.getGiftBoxes(giftBoxType, sorter),
    }),
    detail: (giftBoxId: string, params: GetGiftBoxParams) => ({
        queryKey: [giftBoxId, params],
        queryFn: () => GiftBoxApi.getGiftBox(giftBoxId, params),
    }),
});

export default giftBoxQueries;
